import { Component, ViewChild, TemplateRef, inject } from '@angular/core';
import { AuthenticationService } from 'src/app/service/auth/authentication.service';
import { OrganisationService } from 'src/app/service/organisation/organisation.service';
import { Organisation } from 'src/app/service/organisation/organisation';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'ufla-kontaktdaten',
    templateUrl: './kontaktdaten.component.html',
    styleUrls: [
        './kontaktdaten.component.scss',
    ],
    standalone: false,
})
export class KontaktdatenComponent {
    private snackBar = inject(MatSnackBar);
    private dialog = inject(MatDialog);
    private dialogRef = inject<MatDialogRef<KontaktdatenComponent>>(MatDialogRef);
    private organisationService = inject(OrganisationService);
    private authenticationService = inject(AuthenticationService);


    public organisation: Organisation;
    public originalOrganisation: Organisation;
  @ViewChild('netzbetreiberForm', { static: false }) public netzbetreiberForm: NgForm;
  @ViewChild('errorDialog', { static: false }) errorDialog: TemplateRef<any>;

  constructor() {
      this.authenticationService.user$
          .pipe(takeUntilDestroyed())
          .subscribe(user => {
              this.organisationService.getOrganisation(user.organisationsId)
                  .pipe(takeUntilDestroyed())
                  .subscribe(org => {
                      this.organisation = org;
                      this.originalOrganisation = JSON.parse(JSON.stringify(this.organisation));
                  });
          });
  }

  public updateEmail() {
      const netzbetreiberToBeSent = JSON.parse(JSON.stringify(this.organisation));
      console.log(netzbetreiberToBeSent);
      console.log(this.organisation.id);
      this.organisationService.updateOrganisation(this.organisation.id, netzbetreiberToBeSent)
          .then(_resp => {
              this.snackBar.open('Änderungen gespeichert', 'Ok', {
                  duration: 2000,
              });
          })
          .catch(_ => {
              this.dialog.open(this.errorDialog);
          });
      this.dialogRef.close();
  }

  public cancel() {
      this.dialogRef.close();
  }
}
